import { Component } from '@angular/core';
import { MainService } from '@services';

import { ActivatedRoute } from '@angular/router';
declare var smoothScripts: any;

@Component({
  selector: 'app-interpretimet',
  templateUrl: './interpretimet.component.html',
  styleUrls: ['./interpretimet.component.scss']
})
export class InterpretimetComponent {
  public interpretimet:any[] = [];

  langVariable: string = "";

	constructor(
        private mainService: MainService,
		private route: ActivatedRoute
    ) { 
        this.mainService.isInnerPage = true;
    }

	ngOnInit(): void {
		this.fetchData();

		this.route.queryParams
		.subscribe(params => {
			this.langVariable = params['language'];
			//console.log(this.langVariable);
			if (this.langVariable === undefined) {
			  this.langVariable = "SQ";
			}
		 })
	}
	
	ngAfterViewInit(){
		if(this.mainService.isBrowser){
			// ============================ //
			// JS Layout Init Collapse
			// ============================ //
			smoothScripts.collapse();
		}
	}

	// ============================ //
	// Fetch FAQ Data
	// ============================ //
	fetchData(){
		this.mainService.getInterpretations().subscribe((res:any)=>{
			this.interpretimet = res['data'];
			this.interpretimet = this.interpretimet.sort((a, b) => b.id - a.id);
			this.mainService.updateMetaTitle("Interpretimet");
		});
	}
}
